/* eslint-disable */
import { db } from '@/main'
import config from '../config'

export default {
  namespaced: true,
  state: {
    bills: [],
    loading: false,
    error: null
  },
  mutations: {
    bills (state, payload) {
      state.bills = payload || []
    },
    error (state, payload) {
      state.error = payload
    },
    startAction (state) {
      state.error = null
      state.loading = true
    },
    stopAction (state) {
      state.loading = false
    }
  },
  actions: {
    /**
     * @func
     * @desc query first 25 recent bills / invoices
     * @param [context]
     */
    getRecentBills (context) {
      context.commit('startAction')
      return new Promise((resolve, reject) => {
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .collection('bills')
          .orderBy('invoiceDate', 'desc')
          .limit(25)
          .get()
          .then(querySnapshot => {
            const bills = []
            querySnapshot.forEach(snapshot => {
              const bill = snapshot.data()
              bill.documentId = snapshot.id
              bill.invoiceLink = `https://${config.firebaseConfig.storageBucket}/${bill.invoiceLink}`
              const startStamp = bill.invoiceDate.toDate()
              const endStamp = new Date(startStamp.getFullYear(), startStamp.getMonth(), startStamp.getDate() + 30, 0, 0, 0)
              bill.computedNextInvoiceDate = `${endStamp.getDate()}/${endStamp.getMonth()+1}/${endStamp.getFullYear()}`
              if (bill.payment.timestamp) {
                const paymentTimestamp = bill.payment.timestamp.toDate()
                bill.computedPaymentTimestamp = `${paymentTimestamp.getDate()}/${paymentTimestamp.getMonth()+1}/${paymentTimestamp.getFullYear()}`
              }
              else {
                bill.computedPaymentTimestamp = ''
              }
              bill.period = `${startStamp.getDate()}/${startStamp.getMonth() + 1} - ${endStamp.getDate()}/${endStamp.getMonth() + 1}`
              bills.push(bill)
            })
            console.log('bills', bills)
            context.commit('bills', bills)
            return resolve(bills)
          })
          .catch(error => {
            context.commit('error', error)
            return reject(error)
          })
          .finally(() => {
            return context.commit('stopAction')
          })
      })
    },

    /**
     * @func to get last billed timestamp so front-end can query data correctly
     * @param [context]
     * @return {Promise<unknown>}
     */
    getLastBillTimestamp (context) {
      return new Promise((resolve, reject) => {
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .collection('bills')
          .where('payment.paid', '==', true)
          .orderBy('timestamp', 'desc')
          .limit(1)
          .get()
          .then(querySnapshot => {
            querySnapshot = querySnapshot[0]
            if (!querySnapshot) {
              return resolve({ timestamp: new Date(new Date().setDate(new Date().getDate() - 30)) })
            }
            const data = querySnapshot.data()
            data.documentId = querySnapshot.id
            return resolve({ timestamp: data.timestamp, data: data })
          })
          .catch(error => {
            console.error('error here', error)
            return reject(error)
          })
      })
    }

    // TODO: Download Receipts
  },

  getters: {
    estimateBill (state, getters, rootState) {
      const totalUser = rootState.tenant.totalUsers || 0
      if (totalUser >= 0 && totalUser <= 25) {
        return { charge: '0 USD', plan: '0 - 25 Users' }
      }
      if (totalUser > 25 && totalUser <= 50) {
        return { charge: '15 USD', plan: '25 - 50 Users' }
      }
      if (totalUser > 50 && totalUser <= 100) {
        return { charge: '25 USD', plan: '50 - 100 Users' }
      }
      if (totalUser > 100 && totalUser <= 150) {
        return { charge: '35 USD', plan: '100 - 150 Users' }
      }
      if (totalUser > 150 && totalUser <= 200) {
        return { charge: '45 USD', plan: '150 - 200 Users' }
      }
      if (totalUser > 200 && totalUser <= 300) {
        return { charge: '60 USD', plan: '200 - 300 Users' }
      }
      if (totalUser > 300 && totalUser <= 500) {
        return { charge: '90 USD', plan: '300 - 500 Users' }
      }
      if (totalUser > 500 && totalUser <= 700) {
        return { charge: '120 USD', plan: '500 - 700 Users' }
      }
      if (totalUser > 700 && totalUser <= 900) {
        return { charge: '150 USD', plan: '700 - 900 Users' }
      }
      if (totalUser > 900 && totalUser <= 1200) {
        return { charge: '190 USD', plan: '900 - 1200 Users' }
      }
      if (totalUser > 1200 && totalUser <= 1500) {
        return { charge: '230 USD', plan: '1200 - 1500 Users' }
      }
      if (totalUser > 1500 && totalUser <= 2000) {
        return { charge: '295 USD', plan: '1500 - 2000 Users' }
      }
      if (totalUser > 2000 && totalUser <= 3000) {
        return { charge: '360 USD', plan: '2000 - 3000 Users' }
      }
      if (totalUser > 3000 && totalUser <= 4000) {
        return { charge: '425 USD', plan: '3000 - 4000 Users' }
      }
      if (totalUser > 4000 && totalUser <= 5000) {
        return { charge: '490 USD', plan: '4000 - 5000 Users' }
      }
      return { charge: 'Contact Us', plan: '(Enterprise Plan)' }
    },
    unpaidBill (state) {
      if (!state.bills || state.bills.length < 1) {
        return []
      }
      return state.bills.filter(x => !x.payment.paid)
    },
    dueAmount (state, getters) {
      if (!state.bills || state.bills.length < 1) {
        return 0
      }
      let sum = 0
      getters.unpaidBill.forEach(x => {
        sum += x.payment.total
      })
      return sum
    },
    lastBill (state) {
      if (!state.bills || state.bills.length < 1) {
        return {
          period: 'Need Setup',
          payment: {}
        }
      }
      return state.bills[0]
    }
  }
}
